exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lm-size-navigator{position:absolute;height:100%;left:0;width:176px}", ""]);

// exports
